import { Component, Input } from '@angular/core';
import { RecordingAnswer } from '@modules/activity-edition/core/features/activity-editor-panel/answerTypes';
import { animate, style, transition, trigger } from '@angular/animations';

@Component({
    selector: 'app-activity-edition-preview-recording',
    templateUrl: './activity-edition-preview-recording.component.html',
    animations: [
        trigger('fadeAndSlideInAndOut', [
            transition(':enter', [
                style({ opacity: 0, transform: 'translateX(-1.2rem)' }),
                animate('100ms 100ms ease-in-out', style({ opacity: 1, transform: 'translateX(0)' })),
            ]),
            transition(':leave', [
                style({ opacity: 1, transform: 'translateX(0)' }),
                animate('100ms ease-in-out', style({ opacity: 0, transform: 'translateX(-1.2rem)' })),
            ]),
        ]),
    ],
})
export class ActivityEditionPreviewRecordingComponent {
    @Input() answersState!: RecordingAnswer;
}
